import React, { useState } from 'react';
import styled from 'styled-components';
import { useMutation } from '@apollo/react-hooks';
import { withRouter } from 'react-router-dom';
import Button from './Button';
import colors from '../styles/colors';
import { PASSWORD_RESET } from '../graphql/queries';
import { getErrorMessage } from '../util/ErrorUtil';
import Input from './Input';
import Icon from './Icon';
import Error from './Error';
import Success from './Success';
import { IconEnum as Icons } from './Icons';
import { FadeIn } from './Animation';
import { media } from '../util/MediaQuery';

const Content = styled.div`
  align-items: center;
  justify-content: center;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: ${colors.white};
  position: relative;
  border-radius: 5px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  margin: auto;
  overflow-y: auto;
  ${media.desktop`
    &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
    padding: 30px;
    width: 400px;
  `};

  ${media.mobile`
    height: 100vh;
    width: 100vw;
    padding: 10px;
  `};
  ${media.desktop`
    min-height: 85vh !important;
    max-height: 85vh !important; 
  `};
  ${media.tablet`
    min-height: 100vh;
    max-height: 100vh; 
  `};
`;

const TopText = styled.div`
  font-size: 2rem;
  text-align: center;
`;

const BottomText = styled.div`
  font-size: 1.2rem;
  color: ${(props) => props.color || `${colors.grey3}`};
  cursor: ${(props) => (props.onClick ? 'pointer' : null)};
  text-align: center;
  margin-top: 60px;
`;

const BackContainer = styled.div`
  display: flex;
  cursor: pointer;
  position: absolute;
  align-items: center;
  top: 25px;
  left: 25px;
`;

const BackText = styled.div`
  margin-left: 5px;
  color: ${colors.grey3};
  font-size: 1.4rem;
`;

function ResetPassword({ history }) {
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const code = new URLSearchParams(history.location.search).get('code');
  const [passwordReset, { loading }] = useMutation(PASSWORD_RESET, {
    variables: {
      password,
      code,
    },
    onError(error) {
      setErrorMsg(getErrorMessage(error));
      setSuccessMsg('');
    },
    onCompleted(data) {
      if (data && data.passwordReset && data.passwordReset.message) {
        if (data.passwordReset.status && data.passwordReset.status > 299) {
          setErrorMsg(data.passwordReset.message);
          setSuccessMsg('');
        } else {
          setErrorMsg('');
          setSuccessMsg(data.passwordReset.message);
        }
      } else {
        setErrorMsg('Something went wrong, please contact support');
        setSuccessMsg('');
      }
    },
  });

  if (!code) history.push('/forgotPassword');

  return (
    <>
      <Content>
        <FadeIn duration={0.5}>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              passwordReset();
            }}
          >
            <TopText>Please choose a new password.</TopText>
            <Input
              header="PASSWORD"
              type="password"
              required="required"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              width="100%"
            />
            <Button
              margin="40px 0px"
              text="SET NEW PASSWORD"
              type="submit"
              width="fit-content"
              loading={loading}
            />
            <>
              {errorMsg && <Error error={errorMsg} margin="20px 0px 0px 0px" position="relative" />}
              {successMsg && (
                <Success message={successMsg} margin="20px 0px 0px 0px" position="relative" />
              )}
              {successMsg && (
                <BottomText
                  color={colors.seaGreen}
                  onClick={() => history.push('/login')}
                >
                  &nbsp;&nbsp;&nbsp;GO TO LOGIN
                </BottomText>
              )}
              <BackContainer onClick={() => history.push('/login')}>
                <Icon icon={Icons.LeftArrow} size={14} active />
                <BackText>Back</BackText>
              </BackContainer>
            </>
          </Form>
        </FadeIn>
      </Content>
    </>
  );
}

export default withRouter(ResetPassword);
